export default __webpack_public_path__ + "static/TaberReplay-3b4d811bbca0553b627ed2707cd6ba5d.jpg";